const attributePrefix = 'attr_';

const transformAttributes = attributes => (
  Object.keys(attributes || {}).reduce((acc, attributeKey) => ({
    ...acc,
    [`${attributePrefix}${attributeKey}`]: attributes[attributeKey]
  }), {})
);

export const setTargetingByContentType = ({targeting, targetingContentTypes, nextArticleId, data}) => ({
  ...targetingContentTypes,
  [nextArticleId]: {
    ...targeting,
    articleId: nextArticleId,
    authors: data?.analytics_data?.article_authors_nickname,
    category: data?.analytics_data?.article_categories_slugs,
    tags: data?.analytics_data?.article_tag_slugs,
    ...transformAttributes(data?.analytics_data?.targeting_attributes)
  }
});
